
import hasModel from '~/mixins/hasModel'
import 'keen-slider/keen-slider.min.css'
import KeenSlider from 'keen-slider'

function ThumbnailPlugin(main) {
    return (slider) => {
        function addClickEvents() {
            slider.slides.forEach((slide, idx) => {
                slide.addEventListener('click', () => {
                    main.moveToIdx(idx)
                })
            })
        }

        slider.on('created', () => {
            addClickEvents()
            main.on('animationStarted', (main) => {
                const next = main.animator.targetIdx || 0
                slider.moveToIdx(Math.min(slider.track.details.maxIdx, next))
            })
        })
    }
}

export default {
    mixins: [hasModel],

    data() {
        return {
            selectedImage: 0,
            zoom: false,
            slider: null,
            thumbnail: null,
        }
    },

    computed: {
        lgDevice() {
            return this.$store.getters["data/lgDevice"]
        },
        productImages() {
            return [this.model, ...(this.model?.children || [])].map((x) => x.cover).filter((x) => x).filter(img => !!img.url)
        },
        currentImage() {
            return this.productImages[this.selectedImage] || {}
        },
        prevDisabled() {
            return this.selectedImage === 0
        },
        nextDisabled() {
            return this.selectedImage === this.productImages?.length - 1
        },
    },
    methods: {
        prev() {
            if (this.selectedImage > 0) this.selectedImage -= 1
            else this.selectedImage = 0
        },
        next() {
            if (this.selectedImage < this.productImages?.length - 1) this.selectedImage += 1
            else this.selectedImage = this.productImages?.length - 1
        },
        select(index) {
            if (this.selectedImage !== index) this.selectedImage = index
        },
        zoomIn() {
            this.zoom = true
            document.querySelector('body').classList.add('modal-open')
            this.$nextTick(() => {
                this.slider = new KeenSlider(this.$refs.slider, {
                    initial: this.selectedImage,
                    slideChanged: (s) => {
                        this.selectedImage = s.track.details.rel
                    },
                })

                this.thumbnail = new KeenSlider(
                    this.$refs.thumbnail,
                    {
                        initial: this.selectedImage,
                        slides: {
                            perView: 'auto',
                            spacing: 8,
                        },
                    },
                    [ThumbnailPlugin(this.slider)]
                )
            })
        },
        zoomOut() {
            if (this.slider) this.slider.destroy()
            if (this.thumbnail) this.thumbnail.destroy()
            this.$nextTick(() => {
                this.zoom = false
                document.querySelector('body').classList.remove('modal-open')
            })
        },
    },
}
